import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-cyan-200/70 font-display tracking-widest">
        CHARGEMENT...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") {
    // Players cannot access admin routes — send them home
    return <Navigate to="/" replace />;
  }
  return children;
}
